import { LocationFormItem } from 'components/location/interfaces'

export const toLocationPayload = (values: LocationFormItem, isNewAddress: string) => {
  const {
    locationRegions,
    locationUsageName,
    locationUsageCode,
    legalEntity,
    locationStatus,
    locationSubtype,
    externalIdList,
    city,
    streetName,
    streetNumber,
    entrance,
    floor,
    apartmentNumber,
    postalCode,
    coordinatesX,
    coordinatesY,
    locationAddress
  } = values

  const regionIdList = locationRegions.map(region => region.value)

  const externalIdListPaylod = externalIdList
    .filter(item => item.value)
    .map(item => ({ systemId: item.id, value: item.value }))

  return {
    locationUsageName: locationUsageName,
    locationUsageCode: locationUsageCode,
    legalEntityId: legalEntity?.value,
    locationStatusId: locationStatus?.value,
    locationSubtypeId: locationSubtype?.value,
    ...(regionIdList.length ? { regionIdList } : {}),
    externalIdList: externalIdListPaylod,
    ...(isNewAddress === 'true'
      ? {
          cityId: city.id,
          streetName: streetName,
          streetNumber: streetNumber,
          entrance: entrance,
          ...(floor ? { floor: floor } : {}),
          ...(apartmentNumber ? { apartmentNumber: apartmentNumber } : {}),
          ...(postalCode ? { postalCode: postalCode } : {}),
          ...(coordinatesX ? { coordinatesX: coordinatesX } : {}),
          ...(coordinatesY ? { coordinatesY: coordinatesY } : {})
        }
      : {
          locationAddressId: locationAddress.id
        })
  }
}
